//Used for checking urls on images
export function isVideo(url: string): boolean {
  const videoExtensions = /\.(mp4|webm|mov)$/i;
  return videoExtensions.test(url);
}
